<div class="tabela">
  <table class="custom-table">
    <thead>
      <tr>
        <th *ngFor="let column of visibleColumns">
          {{ column.header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of data; let i = index"
        [ngClass]="{ selected: selectedRowIndex === i }"
        (click)="selectRow(i)">
        <td *ngFor="let column of visibleColumns">
          <ng-container *ngIf="item.hasOwnProperty(column.key)">
            <ng-container [ngSwitch]="column.type">
              <span *ngSwitchCase="'text'">{{ item[column.key] }}</span>

              <ng-container *ngSwitchCase="'checkbox'">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    [checked]="item[column.key]"
                    (change)="column.action ? column.action(item) : null" />
                </label>
              </ng-container>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>
